import React, {useEffect, useRef} from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NewSearchWidgetPopularAndResults} from "./new-search-widget.popular-and-results";
import {NewSearchWidgetRecentSearches} from "./new-search-widget.recent-searches";

export const NewSearchWidgetContent = observer(({controller}) => {
  const {state, device} = controller;
  const {isListSingleView} = state;
  const {isSmallView} = device;

  const ref = useRef(null)

  useEffect(() => {
    if (ref?.current && isSmallView && isListSingleView) {
      ref.current.scrollTop = 0;
    }
  }, [isListSingleView])

  return (
    <div className={classNames(styles.content)} ref={ref}>
      <NewSearchWidgetRecentSearches controller={controller}/>
      <NewSearchWidgetPopularAndResults controller={controller}/>
    </div>
  )
});
